import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Avatar } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';

const OverviewItem = props => {
  const { qrData, cardColor, className, ...rest } = props;
  const classes = useStyles();
  const currency = '฿';

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      style={{ backgroundColor: cardColor }}
    >
      <div>
        <div className={classes.details}>
          <Typography
            color="inherit"
            variant="h3"
          >
            {`${currency}${qrData.amount}`}
          </Typography>
        </div>
        <Typography
          color="inherit"
          component="h2"
          gutterBottom
          variant="overline"
        >
          {`${qrData.name} Balance`}
        </Typography>
        <div className={classes.details}>
          <Typography
            color="inherit"
            variant="h3"
          >
            {`${currency}${qrData.fee}`}
          </Typography>
        </div>
        <Typography
          color="inherit"
          component="h2"
          gutterBottom
          variant="overline"
        >
          {`${qrData.name} Fee`}
        </Typography>
      </div>
      {qrData.name !== 'Total' && (
        <Avatar
          className={classes.avatar}
          color="inherit"
          style={{ color: cardColor }}
        >
          <FontAwesomeIcon
            className={classes.space}
            icon={faQrcode}
          />
        </Avatar>
      )}
    </Card>
  );
};

OverviewItem.propTypes = {
  cardColor: PropTypes.string,
  className: PropTypes.string,
  qrData: PropTypes.object
};

export default OverviewItem;

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    // backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  avatar: {
    backgroundColor: theme.palette.white,
    // color: theme.palette.primary.main,
    height: 48,
    width: 48
  }
}));
